let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("czD8i")).then(() => parcelRequire('b1qIP'));